import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import '../../style/chat.scss';
import { getChatHostname } from '../../common/utils/hostnameUtil'
import { useHistory } from 'react-router-dom';

const ChatHtml = observer(() => {
  const history = useHistory();
  const iframeRef = useRef(null);
  let { chatHostNameWithProtocol } = getChatHostname();

  useEffect(() => {
    const sendMessageToIframe = () => {
      const iframeWindow = iframeRef.current?.contentWindow;
      if (iframeWindow) {
        iframeWindow.postMessage(
          { type: 'SET_PARENT_DOMAIN', payload: window.location.hostname },
          chatHostNameWithProtocol
        );
      }
    };

    // Send message after iframe loads
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener('load', sendMessageToIframe);
    }

    return () => {
      if (iframe) {
        iframe.removeEventListener('load', sendMessageToIframe);
      }
    };
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, payload } = event.data;
      if (type === 'ACTION_OPEN_SPORTS_CHEER') {
        history.push(payload);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, []);


  return (
    <>
      <iframe ref={iframeRef} className="box-chat-iframe" scrolling="no" frameBorder="0" id="livechat"
        src={chatHostNameWithProtocol + '/nlivechat/chat.php'}
      ></iframe>
    </>
  );
});

export default ChatHtml;
